import { createFileRoute } from '@tanstack/react-router'
import IntegrationRequestList from '../components/integration-request-list/IntegrationRequestList'

export const Route = createFileRoute('/_a/integrationRequests')({
  component: IntegrationRequestList,
})
